import { SaveButton } from "components/Buttons"
import { URL_PATHS } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { Col, Container, Row } from "reactstrap"
import { getSelectedBooking, resetSelectedBooking } from "store/actions"

const SuccessBookingScreen = ({
  match,
  selectedBooking,
  getSelectedBooking,
  resetSelectedBooking,
}) => {
  useEffect(() => {
    if (match?.params?.id) {
      getSelectedBooking({ id: match?.params?.id })
    }
    return () => {
      resetSelectedBooking()
    }
  }, [])

  const moment = require("moment-timezone")
  const usersTimezone = moment.tz.guess()

  const getDisplayDate = date => {
    const usersDate = moment.tz(date?.date, date?.timezone)
    return new Date(usersDate)?.toLocaleDateString(
      {},
      {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        timeZone: usersTimezone,
      }
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div style={{ textAlign: "center" }}>
            <Row className="my-3">
              <h3>BOOKING WAS CREATED</h3>
            </Row>
            <Row className="my-3">
              <span>
                The following booking has been created with a pending status.
                {<br />}
                Once the payment is confirmed, the booking will become active.
                {<br />}
              </span>
            </Row>
          </div>
          {selectedBooking && (
            <div
              style={{
                backgroundColor: "#f2f2f2",
                padding: "10px 25px",
                borderRadius: "20px",
                width: "50%",
                margin: "0 auto",
              }}
            >
              <span>
                Calendar: {selectedBooking?.booking_type?.calendar?.name}
              </span>
              {<br />} {<br />}
              <span>
                <b>{selectedBooking?.booking_type?.name}</b>
              </span>
              {<br />}
              <span>
                {getDisplayDate(selectedBooking?.start_date_object)}
                {" ("}
                {usersTimezone}
                {")"}
              </span>
              {<br />} {<br />}
              <span>
                <b>Location: </b>
                {selectedBooking?.booking_type?.location}
              </span>
              {<br />} {<br />}
              <span>
                <b>Name: </b>
                {selectedBooking?.user_name}
              </span>
              {<br />}
              <span>
                <b>Email: </b>
                {selectedBooking?.user_email}
              </span>
              {<br />}
              <span>
                <b>Booked by: </b>
                {selectedBooking?.creator?.first_name}{" "}
                {selectedBooking?.creator?.last_name}
                {" ("}
                {selectedBooking?.creator?.email}
                {")"}
              </span>
              {<br />}
              <span>
                <b>Date booked: </b>
                {getDisplayDate(selectedBooking?.created_at)}
              </span>
              {<br />} {<br />}
              <span>
                <b>Notes: </b>
                {selectedBooking?.notes}
              </span>
            </div>
          )}
          <Row className="d-flex justify-content-center mt-5">
            <Col xs="auto">
              <Link to={URL_PATHS.BOOKING_CALENDAR} className="dropdown-item">
                <SaveButton type="button" content="Go to Bookings Screen" />
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  selectedBooking: state.BookingsFeature.selectedBooking,
})

const mapDispatchToProps = dispatch => ({
  getSelectedBooking: values => dispatch(getSelectedBooking(values)),
  resetSelectedBooking: () => dispatch(resetSelectedBooking()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessBookingScreen)
